import { useEffect } from 'react';
import useSWR from 'swr';

import config from '../../config';
import { channelWithoutProgramsPath } from '../../forces/channels/api';
import { getRequestPathWithAccessToken } from '../../forces/utils/request';
import { useAuthToken } from '../../hooks/useAuthToken';
import { captureExceptionInSentry } from '../../utils/errorTracker/tracking';

export const useTvGuideChannels = ({ includePrograms = false }) => {
  const accessToken = useAuthToken();

  const { data, error, isLoading } = useSWR(
    channelWithoutProgramsPath(includePrograms),
    path =>
      getRequestPathWithAccessToken<RiksTV.ClientAPI.ChannelResponse>(accessToken)(path, {
        url: config.contentSearchApiUrl,
      }),
    {
      // refresh on focus change if more than 5 minutes on idle
      focusThrottleInterval: 300_000,
      // autorefresh every 30 min
      refreshInterval: 1_800_000,
    }
  );

  useEffect(() => {
    if (error) {
      captureExceptionInSentry(error);
    }
  }, [error]);

  return { channels: data, isLoading };
};
